import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

// Newsletter provider endpoint (e.g. Buttondown/ConvertKit form action URL).
// Set VITE_NEWSLETTER_FORM_ACTION in .env.production; component hides itself
// until a provider is configured.
const FORM_ACTION = import.meta.env.VITE_NEWSLETTER_FORM_ACTION as string | undefined;

const EmailCapture = () => {
  const [email, setEmail] = useState("");

  if (!FORM_ACTION) return null;

  return (
    <Card className="max-w-2xl mx-auto border-primary/30">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Mail className="w-5 h-5" />
          Get the full statistical report
        </CardTitle>
        <CardDescription>
          A free deep-dive on the US dating pool: factor-by-factor breakdowns, state
          estimates, and data updates as new Census releases land. No spam, unsubscribe anytime.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form
          action={FORM_ACTION}
          method="post"
          target="_blank"
          onSubmit={() => trackEvent("email_signup_submitted", { location: "post_results" })}
          className="flex flex-col sm:flex-row gap-3"
        >
          <Input
            type="email"
            name="email"
            required
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flex-1"
            aria-label="Email address"
          />
          <Button type="submit">Send me the report</Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default EmailCapture;
